import React, { useState } from 'react';
import * as RadixLabel from '@radix-ui/react-label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';
import {
  errorTextClass,
  inputCls,
  labelClass,
} from 'modules/Common/form/v2/primitives/inputClasses';

export default function PortalPasswordGate({
  operatorName,
  operatorLogoUrl,
  onSubmit,
  loading,
  error,
}) {
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(password);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden">
        <div
          className="h-1 w-full"
          style={{ backgroundColor: 'rgb(var(--primary-color))' }}
        />
        <div className="px-6 pt-6 pb-4 border-b border-slate-100">
          <div className="flex items-center gap-3 mb-1">
            {operatorLogoUrl ? (
              <img
                src={operatorLogoUrl}
                alt={operatorName || 'Operator'}
                className="w-9 h-9 rounded-lg object-cover border border-slate-200 bg-white shrink-0"
              />
            ) : (
              <div
                className="w-9 h-9 rounded-lg border border-slate-200 flex items-center justify-center text-sm font-semibold shrink-0"
                style={{
                  backgroundColor: 'rgb(var(--primary-color) / 0.08)',
                  color: 'rgb(var(--primary-color-dark))',
                }}
              >
                {(operatorName || '?')[0].toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
                CBAM portal
              </div>
              <h1 className="text-base font-semibold text-slate-800 m-0 leading-tight truncate">
                {operatorName || 'Operator'}
              </h1>
            </div>
          </div>
          <p className="text-xs text-slate-400 mt-2 flex items-center gap-1.5">
            <FontAwesomeIcon
              icon={faLock}
              className="text-[10px]"
            />
            Enter the password to view this supplier&apos;s emissions data.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="px-6 py-5 flex flex-col gap-4"
        >
          <div>
            <RadixLabel.Root
              htmlFor="portal-password"
              className={labelClass}
            >
              Password
            </RadixLabel.Root>
            <input
              id="portal-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter password"
              required
              autoFocus
              className={inputCls(!!error, 'mt-1')}
            />
            {error && (
              <p className={`${errorTextClass} flex items-center gap-1.5 mt-1.5`}>
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  className="shrink-0"
                />
                {error}
              </p>
            )}
          </div>

          <CgRadixButton
            type="submit"
            variant="primary"
            size="md"
            disabled={!password}
            loading={loading}
            loadingLabel="Verifying…"
            className="w-full justify-center"
          >
            View portal
          </CgRadixButton>
        </form>
      </div>
    </div>
  );
}
